export default __webpack_public_path__ + "static/media/SansWeb-RegularItalic.268db613.woff";